import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/search.png';
const _hoisted_1 = {
  class: "addPerson"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  style: {
    "margin": "16px 32px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_uploader = _resolveComponent("van-uploader");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "title"
  }, "人脸采集建模（教职工端）", -1)), _createVNode(_component_van_form, {
    ref: "formRef",
    onSubmit: _ctx.onSubmit
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.jobNum,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelForm.jobNum = $event),
        required: "",
        clearable: "",
        "label-align": "top",
        name: "jobNum",
        label: "工号",
        placeholder: "请输入工号",
        rules: [{
          required: true,
          message: '请输入工号'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.modelForm.name = $event),
        required: "",
        clearable: "",
        "label-align": "top",
        name: "name",
        label: "姓名",
        placeholder: "请输入姓名",
        rules: [{
          required: true,
          message: '请输入姓名'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.phone,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.modelForm.phone = $event),
        required: "",
        clearable: "",
        type: "tel",
        "label-align": "top",
        name: "phone",
        label: "手机号码",
        placeholder: "请输入手机号码",
        rules: [{
          required: true,
          message: '请输入手机号码'
        }, {
          validator: _ctx.validPhone,
          message: '请输入正确的手机号码'
        }]
      }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.photoPath,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.modelForm.photoPath = $event),
        required: "",
        "label-align": "top",
        name: "photoPath",
        label: "人脸图片",
        rules: [{
          required: true,
          message: '人脸图片不能为空'
        }]
      }, {
        input: _withCtx(() => [_createVNode(_component_van_uploader, {
          modelValue: _ctx.fileList,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.fileList = $event),
          ref: "upload",
          accept: "image/*",
          "max-count": 1,
          "max-size": 10 * 1024 * 1024,
          "before-read": _ctx.beforeRead,
          "after-read": _ctx.afterRead,
          onOversize: _ctx.onOversize
        }, null, 8, ["modelValue", "before-read", "after-read", "onOversize"])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_button, {
      block: "",
      loading: _ctx.loading,
      "loading-text": "提交中...",
      disabled: _ctx.loading,
      color: "#14E0AB",
      size: "small",
      "native-type": "submit"
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 提交 ")])),
      _: 1
    }, 8, ["loading", "disabled"])])]),
    _: 1
  }, 8, ["onSubmit"]), _cache[7] || (_cache[7] = _createElementVNode("img", {
    class: "search",
    src: _imports_0,
    alt: ""
  }, null, -1))])]);
}